import React from "react";
import { Route, Switch } from "react-router-dom";
import NotFound from "../layouts/NotFound";
import PrivateRoute from "../routing/PrivateRoute";
import AdminDashboard from "../layouts/admin/AdminDashboard";
import AdminLogin from "../auth/AdminLogin";
import ForgotPassword from "../auth/ForgotPassword";
import ChangePasswordWithoutAuth from "../auth/ChangePassword";
import ChangePassword from "../layouts/admin/ChangePassword";
import UsersManagement from "../layouts/admin/UsersManagement";
import TransactionHistory from "../layouts/admin/TransactionHistory";
import UpdateSettings from "../layouts/admin/UpdateSettings";
import UserDetail from "../layouts/admin/UserDetail";
import Invoice from "../layouts/admin/Invoice";
import MatchList from "../layouts/admin/MatchList";
import SingleUserMatchList from "../layouts/admin/SingleUserMatchList";
import AddUser from "../layouts/admin/AddUser";
import ViewUsers from "../layouts/admin/ViewUsers";
import Events from "../layouts/admin/Events";
import EventsDetails from "../layouts/admin/EventsDetails";
import RatingDetails from "../layouts/admin/RatingDetails";
import Flag from "../layouts/admin/Flag";
import RatingListView from "../layouts/admin/RatingListView";
import DeletedUsers from "../layouts/admin/DeletedUsers";
import GivenRating from "../layouts/admin/GivenRating";
import GivenRatingDetails from "../layouts/admin/GivenRatingDetails";
import RadarList from "../layouts/admin/RadarList";
import RadarAttendees from "../layouts/admin/RadarAttendees";
import IDMTrust from "../layouts/admin/IDMTrust";
import IDMerit from "../layouts/admin/IDMerit";
import Brightcheck from "../layouts/admin/Brightcheck";
import Community from "../layouts/admin/Community";
import RequestedCommunity from "../layouts/admin/RequestedCommunity";
import GetAllPosts from "../layouts/admin/GetAllPosts";
import ViewMembers from "../layouts/admin/ViewMembers";
import MyPost from "../layouts/admin/MyPost";

const Routes = (props) => {
  return (
    <Switch>
      <PrivateRoute exact path="/admin-dashboard" component={AdminDashboard} />
      <Route exact path="/admin-login" component={AdminLogin} />
      <Route exact path="/forgot-password" component={ForgotPassword} />
      <Route
        exact
        path="/change-password/:id"
        component={ChangePasswordWithoutAuth}
      />
      <PrivateRoute exact path="/change-password" component={ChangePassword} />
      <PrivateRoute exact path="/user-management" component={UsersManagement} />
      <PrivateRoute exact path="/radar" component={RadarList} />
      <PrivateRoute exact path="/radar-attendees" component={RadarAttendees} />
      <PrivateRoute exact path="/idm-trust" component={IDMTrust} />
      <PrivateRoute exact path="/brightcheck" component={Brightcheck} />

      <PrivateRoute exact path="/community" component={Community} />
      <PrivateRoute exact path="/GetAllPosts" component={GetAllPosts} />
      <PrivateRoute exact path="/Mypost" component={MyPost} />
      <PrivateRoute exact path="/viewMembers" component={ViewMembers} />
      <PrivateRoute
        exact
        path="/requested-community"
        component={RequestedCommunity}
      />
      <PrivateRoute exact path="/idmerit" component={IDMerit} />

      <PrivateRoute
        exact
        path="/delete-user-management"
        component={DeletedUsers}
      />
      <PrivateRoute exact path="/transactions" component={TransactionHistory} />
      <PrivateRoute exact path="/invoice/:id" component={Invoice} />
      <PrivateRoute exact path="/update-settings" component={UpdateSettings} />
      <PrivateRoute exact path="/view-user-detail/:id" component={UserDetail} />
      <PrivateRoute exact path="/match-list" component={MatchList} />
      <PrivateRoute
        exact
        path="/single-match-list/:id"
        component={SingleUserMatchList}
      />
      <PrivateRoute exact path="/add-admin" component={AddUser} />
      <PrivateRoute exact path="/view-admin-list" component={ViewUsers} />
      <PrivateRoute exact path="/events" component={Events} />
      <PrivateRoute exact path="/events/:userid" component={Events} />
      <PrivateRoute
        exact
        path="/events-details/:id"
        component={EventsDetails}
      />
      <PrivateRoute
        exact
        path="/recieved-rating-details/:id"
        component={RatingDetails}
      />
      <PrivateRoute exact path="/flags/:id" component={Flag} />
      <PrivateRoute
        exact
        path="/rating-list-view/:id"
        component={RatingListView}
      />
      <PrivateRoute exact path="/given-rating/:id" component={GivenRating} />
      <PrivateRoute
        exact
        path="/given-rating-details/:id"
        component={GivenRatingDetails}
      />
      <Route component={NotFound} />
    </Switch>
  );
};

export default Routes;
